export default "__VITE_ASSET__B4AUQ_vQ__"